export default __webpack_public_path__ + "static/media/17.5b71015b.jpg";